export default {
  terms:
    'Składając zamówienie, akceptujesz nasze <TermsLink>Warunki i zasady</TermsLink> oraz naszą <PrivacyPolicyLink>Politykę prywatności</PrivacyPolicyLink>.',
};
